module.exports = __webpack_public_path__ + "img/mobile-banner11-th.2b99c12f.jpg";